export const apiBaseUrl: string = "https://payment.bapsanz.org";
export const paypalAppClientIdDev: string = "AZkxTqIW7uxT-qPbtFPm1OyXKLogPi6MMiOGhQWNai3tQe4wTkxJiLMuQEWpiqj1S8XKSsnvRhCA9cRK";
export const paypalAppClientIdProd: string = "AezFQnP0kljatT8IceReol74RdbH8QpwF3Nj-2d2GsbRd4eC6x4jqk_mJTb2oVsMv-R4xoMFGXlG5xoz";
export const auth0ReportApiAudience: string = "http://payments-api";
export const checkoutBaseUrl: string = "https://connect.squareup.com"
